import React from "react";
import PaginaPublica from "../PaginasPublicas/PaginaPublica";
import { imagenesEventosSC } from "./imagenesEventosSC";

function Revista() {
  return <PaginaPublica titulo="Eventos Santa Cruz" imagenes={imagenesEventosSC} />;
}

export default Revista;